import TaskBoardWidget from './TaskBoardWidget'

export default function ITTicketsWidget() {
  return <TaskBoardWidget title="IT Tickets" countLabel="tickets" />
}
